<script setup lang="ts">
import type { BaseFilterOption } from '~/types/filters';

// PROPS
interface Props {
    itemsFrom: Array<BaseFilterOption<number>>;
    itemsTo: Array<BaseFilterOption<number>>;
    collapsed?: boolean;
    fromLabel?: string;
    toLabel?: string;
    anyLabel?: string;
}
const { itemsFrom, itemsTo, collapsed = false, anyLabel } = defineProps<Props>();

// MODELS
const from = defineModel<number | undefined>('from', { required: true });
const to = defineModel<number | undefined>('to', { required: true });

// COMPOSABLES
const { tt } = useTypedI18n();

// DATA
const fromSelectModel = adaptEmptyOptionModel(from);
const toSelectModel = adaptEmptyOptionModel(to);

const fromAnyLabel = computed(() => (collapsed ? tt('slp.filters.from') : (anyLabel ?? tt('slp.filters.anyOption'))));
const toAnyLabel = computed(() => (collapsed ? tt('slp.filters.to') : (anyLabel ?? tt('slp.filters.anyOption'))));
const fromSelectOptions = computed(() => prependEmptyOption(itemsFrom, fromAnyLabel.value));
const toSelectOptions = computed(() => prependEmptyOption(itemsTo, toAnyLabel.value));
</script>

<template>
    <div v-if="collapsed" class="flex flex-row gap-x-1">
        <USelectMenu v-model="fromSelectModel" :items="fromSelectOptions" :search-input="false" value-key="value" />
        <USelectMenu v-model="toSelectModel" :items="toSelectOptions" :search-input="false" value-key="value" />
    </div>
    <template v-else>
        <UFormField :label="fromLabel ?? tt('slp.filters.from')" class="sm:grow">
            <USelectMenu v-model="fromSelectModel" :items="fromSelectOptions" :search-input="false" value-key="value" />
        </UFormField>
        <UFormField :label="toLabel ?? tt('slp.filters.to')" class="sm:grow">
            <USelectMenu v-model="toSelectModel" :items="toSelectOptions" :search-input="false" value-key="value" />
        </UFormField>
    </template>
</template>
